<template>
  <div v-if="message">
    <Message
      :content="content"
      :user="user || {}"
      :timestamp="created"
      :media="message.media"
      :highlights="highlights"
      :type="message.type"
    ></Message>
  </div>
</template>

<script>
import Message from '@/components/Modules/Message/Message'
export default {
  name: 'MessageEvent',
  props: ['created', 'message', 'user', 'conversationLastMessage'],
  components: {
    Message
  },
  computed: {
    highlights() {
      return (
        this.message &&
        this.conversationLastMessage &&
        this.conversationLastMessage.score &&
        this.message._id == this.conversationLastMessage._id
      )
    },
    content() {
      if (this.highlights) {
        let body = this.conversationLastMessage.body
        let highlights = this.conversationLastMessage.highlights
        if (highlights && highlights.length) {
          highlights.forEach((highlight) => {
            let replacements = highlight.texts
              .map((text) => {
                if (text.type === 'hit') {
                  return '<mark>' + text.value + '</mark>'
                } else {
                  return text.value
                }
              })
              .join('')

            let originals = highlight.texts
              .map((text) => {
                return text.value
              })
              .join('')

            body = body.replace(originals, replacements)
          })
        }
        return body
      }

      return this.message.body
    }
  }
}
</script>
